export const en = {
	COMMON: {
		"in-stock": "In stock",
		CargoBranch: "Cargo branch",
		PUDO: "Pick-up Location",
		PostBranch: "Post branch",
		Postomat: "Postomat",
		accepted: "In work",
		active: "Active",
		admin: "Admin",
		allowCustomText: "Allow custom text",
		allowedCustomText: "Allowed custom text",
		amount: "Amount",
		appartment: "Appartment",
		apply: "Apply",
		area: "Area",
		areaRef: "Area reference",
		booked: "Booked",
		branchAddress: "Branch address",
		branchId: "Branch id",
		branchRef: "Branch reference",
		callback: "Callback",
		cancel: "Cancel",
		canceled: "Canceled",
		city: "City",
		cityRef: "City reference",
		clear: "Clear",
		closed: "Closed",
		code: "Code",
		collection: "Collection",
		collections: "Collections",
		color: "Color",
		colors: "Colors",
		comment: "Comment",
		components: "Components",
		country: "Country",
		courier: "Courier",
		created: "Created",
		createdAt: "Created at",
		credentials: "Credentials",
		currency: "Currency",
		customer: "Customer",
		customerHistory: "Customer history",
		customers: "Customers",
		deleting: "Deleting",
		deliveryMethod: "Delivery method",
		deliveryMethodDescription: "Delivery method description",
		description: "Description",
		discount: "Discount",
		discounted: "Discounted",
		discountedPrice: "Discounted price",
		divisionAddress: "Division address",
		divisionCategory: "Division category",
		divisionId: "Division id",
		divisionName: "Division name",
		draft: "Draft",
		email: "Email",
		expired: "Expired",
		fail: "Fail",
		failure: "Failure",
		failureReason: "Failure reason",
		features: "Features",
		file: "File",
		filters: "Filters",
		finalAmount: "Final amount",
		firstName: "First name",
		generalInfo: "General information",
		group: "Group",
		height: "Height",
		hex: "Hex",
		history: "History",
		hold: "Hold",
		image: "Image",
		images: "Images",
		inactive: "Inactive",
		init: "Initialization",
		invite: "Invite",
		invoiceId: "Invoice id",
		item: "Item",
		itemPrototype: "Item prototype",
		itemPrototypes: "Item prototypes",
		items: "Items",
		keywords: "Keywords",
		kind: "Kind",
		kinds: "Kinds",
		language: "Language",
		lastName: "Last name",
		length: "Length",
		locale: "Locale",
		login: "Login",
		manager: "Manager",
		market: "Market",
		material: "Material",
		materials: "Materials",
		method: "Method",
		name: "Name",
		namePlural: "Name (plural)",
		no: "No",
		noCancel: "No, cancel",
		nonce: "Nonce",
		note: "Note",
		notifications: "Notifications",
		np_box: "Post machine NP",
		np_brnm: "Nova post",
		opened: "Opened",
		order: "Order",
		orders: "Orders",
		password: "Password",
		payment: "Payment",
		paymentHistory: "Payment history",
		paymentMethod: "Payment method",
		paymentMethodDescription: "Payment method description",
		phoneNumber: "Phone number",
		pickup: "Pickup",
		policy: "Policy",
		porch: "Porch",
		postOffice: "Post office",
		preview: "Preview",
		price: "Price",
		priceForCustomText: "Price for custom text",
		pricePolicies: "Price policies",
		pricePolicy: "Price policy",
		processing: "Processing",
		products: "Products",
		profile: "Profile",
		prototype: "Prototype",
		publish: "Publish",
		register: "Register",
		requested: "Requested",
		restock: "Restock",
		reversed: "Reversed",
		roles: "Roles",
		save: "Save",
		search: "Search",
		settings: "Settings",
		shipping: "Shipping",
		shippingHistory: "Shipping history",
		shippingMethod: "Shipping method",
		shippingMethods: "Shipping methods",
		showOnMainPage: "Show on main page",
		showingOnMainPage: "Showing on main page",
		signOut: "Sign out",
		size: "Size",
		sizes: "Sizes",
		sku: "SKU",
		sold: "Sold",
		state: "State",
		status: "Status",
		street: "Street",
		subscribeToTelegramBot: "Subscribe to Telegram Bot",
		subtotal: "Subtotal",
		success: "Success",
		summary: "Summary",
		tag: "Tag",
		tags: "Tags",
		team: "Team",
		text: "Text",
		thumbnail: "Thumbnail",
		total: "Total",
		translations: "Translations",
		transparent: "Transparent",
		type: "Type",
		updatedAt: "Updated at",
		user: "User",
		width: "Width",
		yes: "Yes",
		yesClose: "Yes, close",
		yesDelete: "Yes, delete",
		yesRefund: "Yes, refund",
		yesReject: "Yes, reject"
	},
	INPUT: {
		PLACEHOLDER: {
			areaName: "CA",
			areaRef: "00000000-0000-0000-0000-000000000000",
			branchAddress: "Howard St.",
			branchId: "00000000-0000-0000-0000-000000000000",
			cityId: "00000000-0000-0000-0000-000000000000",
			cityName: "San Francisco",
			cityRef: "00000000-0000-0000-0000-000000000000",
			cityType: "City",
			code: "****",
			collection: "Collection #1",
			color: "White",
			deliveryMethodDescription: "Nova Post Branch",
			description: "Acrylic topper",
			divisionAddress: "11206, United States, New York, New York, 943 BROADWAY",
			divisionName: "SKY BLUE WIRELESS INC.",
			email: "john{'@'}doe.com",
			firstName: "John",
			hex: "#ffffff",
			itemPrototype: "Topper #1",
			keywords: "happy, birthday...",
			kind: "Topper | Toppers",
			lastName: "Doe",
			material: "White Acrylic",
			note: "Broken part, glued...",
			password: "********",
			phoneNumber: "+10123456789",
			search: "Search",
			selectCollection: "Select collection...",
			selectColor: "Select color...",
			selectDeliveryMethod: "Select delivery method...",
			selectDivisionCategory: "Select division category...",
			selectKind: "Select kind...",
			selectLanguage: "Select language...",
			selectMaterial: "Select material...",
			selectSize: "Select size...",
			selectTag: "Select tag...",
			sku: "6006006",
			tag: "Sale",
			text: "Sweet 16"
		},
		areaName: {
			error: {
				required: "Area Name must be specified"
			}
		},
		areaRef: {
			error: {
				required: "Area Ref must be specified"
			}
		},
		amount: {
			error: {
				integer: "Amount must be a whole number",
				min: "Amount must be greater than or equal to 1",
				max: "Amount must be less than or equal to 100"
			}
		},
		branchAddress: {
			error: {
				required: "Branch Address must be specified"
			}
		},
		branchId: {
			error: {
				required: "Branch Id must be specified"
			}
		},
		cityId: {
			error: {
				required: "City Id must be specified"
			}
		},
		cityName: {
			error: {
				required: "City Name must be specified"
			}
		},
		cityRef: {
			error: {
				required: "City Ref must be specified"
			}
		},
		cityType: {
			error: {
				required: "City Type must be specified"
			}
		},
		name: {
			error: {
				required: "Name must be specified"
			}
		},
		code: {
			error: {
				required: "Code must be specified"
			}
		},
		color: {
			addOptionText: "Add color",
			noItemsText: "No colors to show"
		},
		collection: {
			addOptionText: "Add collection",
			noItemsText: "No collections to show"
		},
		divisionCategory: {
			error: {
				required: "Delivery category must be specified"
			}
		},
		divisionName: {
			error: {
				required: "Delivery name must be specified"
			}
		},
		divisionAddress: {
			error: {
				required: "Delivery address must be specified"
			}
		},
		hex: {
			error: {
				required: "Hex must be specified",
				hex: "Invalid hex color format"
			}
		},
		email: {
			error: {
				required: "Email must be specified",
				email: "Invalid email"
			}
		},
		firstName: {
			error: {
				required: "First Name must be specified"
			}
		},
		material: {
			addOptionText: "Add material",
			noItemsText: "No materials to show",
			error: {
				required: "Material must be specified",
				min: "Select at least one material"
			}
		},
		method: {
			error: {
				required: "Delivery Method must be specified"
			}
		},
		methodDescription: {
			error: {
				required: "Delivery Method Description must be specified"
			}
		},
		lastName: {
			error: {
				required: "Last Name must be specified"
			}
		},
		language: {
			error: {
				required: "Language must be specified"
			}
		},
		kind: {
			error: {
				required: "Kind must be specified"
			}
		},
		keywords: {
			title: "Keywords (separated by commas)"
		},
		password: {
			error: {
				required: "Password must be specified",
				min: "Password must be at least 8 characters",
				max: "Password must be at most 64 characters",
				weak: "Password is too weak"
			}
		},
		phoneNumber: {
			error: {
				required: "Phone number must be specified"
			}
		},
		price: {
			error: {
				required: "Price must be specified",
				requiredByCondition: "Price must be defined as policy is not specified",
				gt: "Price must be greater than or equal to 0.01",
				gte: "Price must be greater or equal to 0"
			}
		},
		roles: {
			title: "Roles (separated by commas)",
			error: {
				required: "Roles must be specified",
				min: "Select at least one role"
			}
		},
		size: {
			addOptionText: "Add size",
			noItemsText: "No sizes to show",
			error: {
				min: "Select at least one size",
				required: "Size must be specified"
			}
		},
		sku: {
			error: {
				invalid: "Invalid SKU"
			}
		},
		discountedPrice: {
			error: {
				gt: "Discounted price must be greater than or equal to 0.01",
				lt: "Discounted price must be less than price"
			}
		},
		tag: {
			addOptionText: "Add tag",
			noItemsText: "No tags to show"
		},
		width: {
			error: {
				gte: "Width must be greater than or equal to 0",
				positive: "Width must be a positive number"
			}
		},
		height: {
			error: {
				gte: "Height must be greater than or equal to 0",
				positive: "Height must be a positive number"
			}
		},
		length: {
			error: {
				gte: "Length must be greater than or equal to 0",
				positive: "Length must be a positive number"
			}
		},
		telegram: {
			title: "Telegram id",
			error: {
				invalid: "Invalid Telegram id"
			}
		}
	},
	COMPONENTS: {
		APP: {
			DROPZONE: {
				dropFilesToStartUpload: "Drop files to start upload",
				dropYourImagesHereOr: "Drop your images here, or ",
				clickToBrowse: "click to browse",
				maxSize: "Max size 10MB each"
			}
		},
		COLLECTIONS: {
			BUTTON_NEW: {
				title: "Create collection"
			},
			CONFIRM_DELETE: {
				title: "Delete collection",
				description:
					"Are you sure you want to delete '{collectionName}' collection?",
				alert: {
					title: "Collection deleted!",
					description: "You deleted '{collectionName}'"
				}
			},
			MENU: {
				edit: "Edit collection",
				delete: "Delete collection"
			},
			MODAL_EDIT: {
				title: "Edit collection",
				alert: {
					title: "Collection details changed!",
					description: "'{collectionName}' collection updated"
				}
			},
			TABLE: {
				noItemsText: "No collections to show"
			}
		},
		COLORS: {
			BUTTON_NEW: {
				title: "Create color"
			},
			CONFIRM_DELETE: {
				title: "Delete color",
				description: "Are you sure you want to delete '{colorName}' color?",
				alert: {
					title: "Color deleted!",
					description: "You deleted '{colorName}'"
				}
			},
			MENU: {
				edit: "Edit color",
				delete: "Delete color"
			},
			MODAL_EDIT: {
				title: "Edit color",
				alert: {
					title: "Color details changed!",
					description: "'{colorName}' color updated"
				}
			},
			TABLE: {
				noItemsText: "No colors to show"
			}
		},
		COMMON: {
			TABLE: {
				results: "{resultsToShow} of {total} results",
				pagination: "{currentPage} of {pageCount}"
			}
		},
		CUSTOMER_HISTORIES: {
			TABLE: {
				noItemsText: "No customer history to show"
			}
		},
		CUSTOMERS: {
			MENU: {
				goto: "Go to customer",
				edit: "Edit customer"
			},
			MODAL_EDIT: {
				title: "Edit customer",
				alert: {
					title: "Customer details changed!",
					description: "'{email}' customer updated"
				}
			},
			TABLE: {
				noItemsText: "No customers to show"
			}
		},
		ITEM_PROTOTYPES: {
			BUTTON_SEARCH: {
				title: "Search by SKU"
			},
			BUTTON_NEW: {
				title: "Create item prototype"
			},
			CONFIRM_DELETE: {
				title: "Delete item prototype",
				description:
					"Are you sure you want to delete '{itemPrototypeName}' item prototype?",
				alert: {
					title: "Item prototype deleted!",
					description: "You deleted '{itemPrototypeName}'"
				}
			},
			MENU: {
				restock: "Restock items",
				edit: "Edit item prototype",
				delete: "Delete item prototype"
			},
			TABLE: {
				noItemsText: "No item prototypes to show"
			}
		},
		ITEMS: {
			ADD_FORM: {
				button: {
					title: "Add {amount} item(s)"
				}
			},
			CONFIRM_DELETE: {
				title: "Delete item",
				description: "Are you sure you want to delete the item?",
				alert: {
					title: "Item deleted!",
					description: "You deleted the item"
				}
			},
			CONFIRM_DELETE_MULTIPLE: {
				title: "Delete item(s)",
				description: "Are you sure you want to delete {count} item(s)?",
				loadingAlert: {
					title: "Deleting {total} items"
				},
				alert: {
					title: "Item(s) deleted!",
					description: "You deleted {count} item(s)"
				}
			},
			MENU: {
				edit: "Edit item",
				delete: "Delete item"
			},
			MENU_MULTIPLE: {
				edit: "Edit {count} item(s)",
				delete: "Delete {count} item(s)"
			},
			TABLE: {
				noItemsText: "No items to show"
			}
		},
		KINDS: {
			BUTTON_NEW: {
				title: "Create kind"
			},
			CONFIRM_DELETE: {
				title: "Delete kind",
				description: "Are you sure you want to delete '{kindName}' kind?",
				alert: {
					title: "Kind deleted!",
					description: "You deleted '{kindName}'"
				}
			},
			MENU: {
				edit: "Edit kind",
				delete: "Delete kind"
			},
			MODAL_EDIT: {
				title: "Edit kind",
				alert: {
					title: "Kind details changed!",
					description: "'{kindName}' kind updated"
				}
			},
			TABLE: {
				noItemsText: "No kinds to show"
			}
		},
		LAYOUT: {
			SIDE: {
				TEAM: {
					title: "Your team",
					INVITE: {
						title: "Invite your team"
					}
				}
			}
		},
		MATERIALS: {
			BUTTON_NEW: {
				title: "Create material"
			},
			CONFIRM_DELETE: {
				title: "Delete material",
				description:
					"Are you sure you want to delete '{materialName}' material?",
				alert: {
					title: "Material deleted!",
					description: "You deleted '{materialName}'"
				}
			},
			MENU: {
				edit: "Edit material",
				delete: "Delete material"
			},
			TABLE: {
				noItemsText: "No materials to show"
			}
		},
		ORDERS: {
			CONFIRM_CLOSE: {
				title: "Close order",
				description: "Are you sure you want to close order #{nonce}?",
				alert: {
					title: "Order closed!",
					description: "You closed order #{nonce}"
				}
			},
			CONFIRM_REJECT: {
				title: "Reject order",
				description: "Are you sure you want to reject order #{nonce}?",
				alert: {
					title: "Order rejected!",
					description: "You rejected order #{nonce}"
				}
			},
			CONFIRM_REFUND: {
				title: "Refund payment",
				description:
					"Are you sure you want to refund payment for order #{nonce}?",
				alert: {
					title: "Payment refunded!",
					description: "Yout refund payment for order #{nonce}"
				}
			},
			MENU: {
				accept: "Accept order",
				reject: "Reject order",
				close: "Close order",
				refund: "Refund payment",
				alert: {
					title: "Order accepted!",
					description: "You accepted order #{nonce}"
				}
			},
			TABLE: {
				noItemsText: "No orders to show"
			}
		},
		PAYMENT_HISTORIES: {
			TABLE: {
				noItemsText: "No payment histories to show"
			}
		},
		PAYMENTS: {
			MENU: {
				goto: "Go to payment"
			}
		},
		PRICE_POLICIES: {
			BUTTON_NEW: {
				title: "Create price policy"
			},
			CONFIRM_DELETE: {
				title: "Delete price policy",
				description:
					"Are you sure you want to delete '{pricePolicy}' price policy?",
				alert: {
					title: "Price policy deleted!",
					description: "You deleted '{pricePolicy}'"
				}
			},
			MENU: {
				edit: "Edit price policy",
				delete: "Delete price policy"
			},
			TABLE: {
				noItemsText: "No price policies to show"
			}
		},
		PROFILE: {
			MODAL_EDIT: {
				alert: {
					title: "Profile details changed!"
				}
			}
		},
		SHIPPING_HISTORIES: {
			TABLE: {
				noItemsText: "No shipping histories to show"
			}
		},
		SHIPPINGS: {
			MENU: {
				goto: "Go to shipping",
				edit: "Edit shipping"
			},
			MODAL_EDIT: {
				title: "Edit shipping",
				alert: {
					title: "Shipping details changed!",
					description: "Shipping for {firstName} {lastName} is updated"
				}
			}
		},
		SIZES: {
			BUTTON_NEW: {
				title: "New size"
			},
			CONFIRM_DELETE: {
				title: "Delete size",
				description: "Are you sure you want to delete '{sizeName}' size?",
				alert: {
					title: "Size deleted!",
					description: "You deleted '{sizeName}'"
				}
			},
			MENU: {
				edit: "Edit size",
				delete: "Delete size"
			},
			MODAL_EDIT: {
				title: "Edit size",
				alert: {
					title: "Size details changed!",
					description: "'{sizeName}' size updated"
				}
			},
			TABLE: {
				noItemsText: "No sizes to show"
			}
		},
		TAGS: {
			BUTTON_NEW: {
				title: "New tag"
			},
			CONFIRM_DELETE: {
				title: "Delete tag",
				description: "Are you sure you want to delete '{tagName}' tag?",
				alert: {
					title: "Tag deleted!",
					description: "You deleted '{tagName}'"
				}
			},
			MENU: {
				edit: "Edit tag",
				delete: "Delete tag"
			},
			MODAL_EDIT: {
				title: "Edit tag",
				alert: {
					title: "Tag details changed!",
					description: "'{tagName}' tag updated"
				}
			},
			TABLE: {
				noItemsText: "No tags to show"
			}
		},
		TEAM: {
			MENU: {
				edit: "Edit user details"
			},
			MODAL_EDIT: {
				title: "Edit user details",
				alert: {
					title: "User permissions changed!",
					description: "'{email}' details updated"
				}
			},
			MODAL_INVITE: {
				title: "Invite user",
				alert: {
					title: "Invite sent!"
				}
			},
			TABLE: {
				noItemsText: "No team members to show"
			}
		},
		TRANSLATION: {
			TABLE: {
				noItemsText: "No translations to show"
			}
		}
	},
	PAGES: {
		COMPONENTS: {
			COLORS: {
				COLOR: {
					translations: {
						description: "List of translations for given color"
					}
				},
				CREATE: {
					title: "Create a new color",
					generalInfo: {
						description: "Fulfill color details"
					},
					preview: {
						description: "Handy way to put it all together"
					},
					alert: {
						title: "New color created!",
						description: "'{colorName}' color created"
					}
				}
			},
			KINDS: {
				KIND: {
					translations: {
						description: "List of translations for given kind"
					}
				},
				CREATE: {
					title: "Create a new kind",
					generalInfo: {
						description: "Fulfill kind details"
					},
					preview: {
						description: "Handy way to put it all together"
					},
					alert: {
						title: "New kind created!",
						description: "'{kindName}' kind created"
					}
				}
			},
			MATERIALS: {
				MATERIAL: {
					translations: {
						description: "List of translations for given material"
					},
					colors: {
						description: "Colors used within material"
					}
				},
				CREATE: {
					title: "Create a new material",
					generalInfo: {
						description: "Fulfill material details"
					},
					colors: {
						description: "Add one or few colors"
					},
					preview: {
						description: "Handy way to put it all together"
					},
					alert: {
						title: "New material created!",
						description: "'{materialName}' material created"
					}
				},
				EDIT: {
					MATERIAL: {
						title: "Edit material",
						generalInfo: {
							description: "Fulfill material details"
						},
						colors: {
							description: "Add one or few colors"
						},
						preview: {
							description: "Handy way to put it all together"
						},
						alert: {
							title: "Material details changed!",
							description: "'{materialName}' material updated"
						}
					}
				}
			},
			SIZES: {
				CREATE: {
					title: "Create a new size",
					generalInfo: {
						description: "Fulfill size details"
					},
					preview: {
						description: "Handy way to put it all together"
					},
					alert: {
						title: "New size created!",
						description: "'{sizeName}' size created"
					}
				}
			}
		},
		CUSTOMERS: {
			CUSTOMER: {
				orders: {
					title: "Orders ({count})",
					description: "List of orders placed by customer"
				},
				customerHistory: {
					description: "List of last changes to customer information"
				}
			},
			INDEX: {
				description: "Browse the customers of {companyName} store"
			}
		},
		ORDERS: {
			ORDER: {
				shipping: {
					description: "Shipping details about recipient"
				},
				payment: {
					description: "Payment details"
				},
				customer: {
					description: "Customer which made an order"
				}
			},
			INDEX: {
				description: "Browse the orders of {companyName} store"
			}
		},
		PAYMENTS: {
			PAYMENT: {
				paymentHistory: {
					description: "List of last changes to payment information"
				}
			}
		},
		PRICE_POLICIES: {
			EDIT: {
				POLICY: {
					title: "Edit price policy",
					generalInfo: {
						description: "Fulfill price policy details"
					},
					materials: {
						description: "Add one or few materials"
					},
					sizes: {
						description: "Add one or few sizes"
					},
					preview: {
						description: "Handy way to put it all together"
					},
					alert: {
						title: "Price policy details changed!",
						description: "'{pricePolicy}' price policy updated"
					}
				}
			},
			POLICY: {
				materials: {
					description: "List of materials which affected by price policy"
				},
				sizes: {
					description: "List of sizes which affected by price policy"
				}
			},
			CREATE: {
				title: "Create a new price policy",
				generalInfo: {
					description: "Fulfill price policy details"
				},
				materials: {
					description: "Add one or few materials"
				},
				sizes: {
					description: "Add one or few sizes"
				},
				preview: {
					description: "Handy way to put it all together"
				},
				alert: {
					title: "New price policy created!",
					description: "'{pricePolicy}' price policy created"
				}
			},
			INDEX: {
				description:
					"Manage generic prices which automatically set up for new items"
			}
		},
		PRODUCTS: {
			COLLECTIONS: {
				COLLECTION: {
					translations: {
						description: "List of translations for given collection"
					}
				},
				CREATE: {
					title: "Create a new collection",
					generalInfo: {
						description: "Fulfill collection details"
					},
					preview: {
						description: "Handy way to put it all together"
					},
					alert: {
						title: "New collection created!",
						description: "'{collectionName}' collection created"
					}
				}
			},
			ITEM_PROTOTYPES: {
				EDIT: {
					PROTOTYPE: {
						title: "Edit item prototype",
						generalInfo: {
							description: "Fulfill item prototype details"
						},
						features: {
							description: "Fulfill item prototype features"
						},
						materials: {
							description: "Add one or few materials"
						},
						sizes: {
							description: "Add one or few sizes"
						},
						images: {
							description: "Add one or few images"
						},
						collections: {
							description: "Add one or few collections"
						},
						tags: {
							description: "Add one or few tags"
						},
						preview: {
							description: "Handy way to put it all together"
						},
						alert: {
							title: "Item prototype details changed!",
							description: "'{itemPrototypeName}' item prototype updated"
						}
					}
				},
				ITEMS: {
					ITEM: {
						order: {
							description: "Order that contains the item"
						}
					},
					CREATE: {
						title: "Add new item(s)",
						generalInfo: {
							description: "Fulfill item details"
						},
						table: {
							title: "Items to restock",
							description: "Items which will be listed"
						},
						preview: {
							description: "Handy way to put it all together"
						},
						loadingAlert: {
							title: "Creating {count} of {total} items"
						},
						alert: {
							title: "New item(s) created!",
							description: "'{total}' items created"
						}
					},
					EDIT: {
						title: "Edit {count} item(s)",
						generalInfo: {
							description: "Fulfill item details"
						},
						preview: {
							description: "Handy way to put it all together"
						},
						loadingAlert: {
							title: "Updating {count} of {total} items"
						},
						alert: {
							title: "Item(s) details changed!",
							description: "'{total}' items updated"
						}
					}
				},
				PROTOTYPE: {
					translations: {
						description: "List of translations for given item prototype"
					},
					images: {
						description: "Images used within item prototype"
					},
					items: {
						description: "Items which using item prototype"
					},
					materials: {
						description: "Materials used within item prototype"
					},
					sizes: {
						description: "Sizes used within item prototype"
					}
				},
				CREATE: {
					title: "Create a new item prototype",
					generalInfo: {
						description: "Fulfill item prototype details"
					},
					features: {
						description: "Fulfill item prototype features"
					},
					materials: {
						description: "Add one or few materials"
					},
					sizes: {
						description: "Add one or few sizes"
					},
					images: {
						description: "Add one or few images"
					},
					collections: {
						description: "Add one or few collections"
					},
					tags: {
						description: "Add one or few tags"
					},
					preview: {
						description: "Handy way to put it all together"
					},
					alert: {
						title: "New item prototype created!",
						description: "'{itemPrototypeName}' item prototype created"
					}
				}
			},
			TAGS: {
				CREATE: {
					title: "Create a new tag",
					generalInfo: {
						description: "Fulfill tag details"
					},
					preview: {
						description: "Handy way to put it all together"
					},
					alert: {
						title: "New tag created!",
						description: "'{tagName}' tag created"
					}
				}
			}
		},
		SEARCH: {
			title: "Search by SKU"
		},
		SETTINGS: {
			TEAM: {
				INDEX: {
					description: "Manage users of your {companyName} admin panel",
					button: {
						title: "Invite user"
					}
				}
			},
			INDEX: {
				description: "Configure the {companyName} admin panel",
				button: {
					team: {
						description: "Manage users of your {companyName} admin panel"
					},
					profile: {
						description: "Edit personal settings"
					}
				}
			}
		},
		SHIPPINGS: {
			SHIPPING: {
				shippingHistory: {
					description: "List of last changes to shipping information"
				}
			}
		},
		LOGIN: {
			alert: {
				description: "You logged in!"
			}
		},
		REGISTER: {
			alert: {
				title: "Your account was created!",
				description:
					"Congratulations! You just created an account. Now you can login"
			}
		}
	}
};
